import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addWhatsappTemplate, getWhatsappTemplates, addWhatsappCampaign } from "network/service";
import Autocomplete from "@mui/material/Autocomplete";
import { uploadFile } from "network/service";

export default function AddCampaignPopup(props) {
    const [newField, setNewField] = useState({ name: "", variables: "", content: '' });
    const [errors, setErrors] = useState({});
    const { showNotification } = useNotification();
    const [roles, setRoles] = useState([]);
    const [selFile, setSelFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [templs, setTmpls] = useState([]);
    const [seltmp, setSelTmp] = useState(null);

    const validate = () => {
        let isValid = true;
        let newErrors = {};
        setErrors(newErrors);
        return isValid;
    }

    useEffect(() => {
        getWhatsappTemplates().then((resp) => {
            setTmpls(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    const submit = async () => {
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append('file', selFile);
            let fileresp = await uploadFile(formData);
            console.log(fileresp.data.path);
            await addWhatsappCampaign({
                template: seltmp._id,
                file: `uploads/${fileresp.data.path}`
            });
            setLoading(false);
            props.handlesuccess();
        } catch (err) {
            console.error("Error Adding Campaign:", err);
            setLoading(false);
            showNotification("error", "Error", "Failed to add Campaign.");
        }
    };

    const handleFileChange = (event) => {
        // Get the selected file from the input
        const sel_file = event.target.files[0];
        setSelFile(sel_file);
    };

    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >
            <div>
                <DialogTitle>{'Add Campaign'}</DialogTitle>
            </div>
            <DialogContent sx={{ minWidth: 500 }}>
                <Grid container direction="column" spacing={2}>
                    <Grid item >
                        <Autocomplete
                            disableClearable
                            label={"Template"}
                            sx={{ flexGrow: 1 }}
                            options={templs}
                            getOptionLabel={(option) => option.name || ''}
                            renderInput={(params) => <MDInput {...params} label={"Template"} fullWidth />}
                            onChange={(event, newValue) => {
                                setSelTmp(newValue)
                            }}
                            value={seltmp}
                        />
                    </Grid>
                    <Grid item>
                        <MDInput fullWidth type="file" disabled={loading} onChange={handleFileChange}></MDInput>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="error" onClick={props.handleclose}>
                    <Icon>close</Icon>&nbsp;
                    Cancel
                </MDButton>
                <MDButton variant="gradient" color="success" onClick={submit}>
                    <Icon>save</Icon>&nbsp;
                    Submit
                </MDButton>
            </DialogActions>
        </Dialog>
    )
}
